import { MaskedLines, Reveal } from "@/components/Motion";
import QuoteForm from "@/components/QuoteForm";
import { CONTACT } from "@/data/site";
import { Phone, Clock, ShieldCheck, Leaf } from "lucide-react";

const PERKS = [
  { icon: Clock, t: "Fast response", d: "Most quotes answered within a few hours." },
  { icon: ShieldCheck, t: "100% satisfaction", d: "Police-checked pros & a re-clean guarantee." },
  { icon: Leaf, t: "Eco-friendly", d: "Low-tox products safe for family & pets." },
];

export default function Quote() {
  return (
    <section className="pt-40 pb-24 bg-[#FAFAF9] min-h-screen">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5">
          <p className="kicker mb-6">Free quote</p>
          <h1 className="font-display font-extrabold tracking-tight text-[#1C2A39] text-5xl sm:text-6xl leading-[0.95]">
            <MaskedLines lines={["Get your", "free quote."]} />
          </h1>
          <Reveal delay={0.5}>
            <p className="mt-7 text-lg text-[#475569] max-w-md">Tell us a little about your space and we'll send you a transparent, no-obligation quote — fast.</p>
          </Reveal>
          <Reveal delay={0.6}>
            <div className="mt-10 space-y-6">
              {PERKS.map((p) => (
                <div key={p.t} className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-2xl bg-[#E8F1EB] flex items-center justify-center shrink-0">
                    <p.icon size={20} className="text-[#0D9488]" strokeWidth={1.7} />
                  </div>
                  <div>
                    <h3 className="font-display font-medium text-lg text-[#1C2A39]">{p.t}</h3>
                    <p className="text-sm text-[#475569]">{p.d}</p>
                  </div>
                </div>
              ))}
            </div>
            <a href={`tel:${CONTACT.phoneRaw}`} className="btn-ghost mt-10"><Phone size={17} /> Prefer to call? {CONTACT.phone}</a>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.3}><QuoteForm /></Reveal>
        </div>
      </div>
    </section>
  );
}
